import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { Loader } from '@calendly/ui/components/loader'

import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import { ConfirmationFooter } from 'components/sso_confirmation_footer'
import { Container, CookieSettingsButton } from 'components/confirmation/layout'

import { Links } from './links'
import { ConfirmationHeader } from './confirmation_header'
import { ConfirmationDetails } from './confirmation_details'
import PackageDetails from './package_details'
import _CookieSettingsWrapper from "index-CookieSettingsWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/confirmation/pages/new_confirmation/index.js?styleId=CookieSettingsWrapper";
import _DetailsWrapper from "index-DetailsWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/confirmation/pages/new_confirmation/index.js?styleId=DetailsWrapper";


const CookieSettingsWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "CookieSettingsWrapper",
  styles: _CookieSettingsWrapper,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const Confirmation = () => {
  const { eventType, showFooter } = useConfirmationPageData()
  if (eventType === undefined) return <Loader />

  return (
    <Container>
      <ConfirmationHeader />
      <DetailsWrapper>
        <ConfirmationDetails />
        <PackageDetails eventTypeUuid={eventType?.uuid} />
      </DetailsWrapper>
      {showFooter && <ConfirmationFooter />}
      <Links />
      <CookieSettingsWrapper>
        <CookieSettingsButton />
      </CookieSettingsWrapper>
    </Container>
  )
}

const DetailsWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "DetailsWrapper",
  styles: _DetailsWrapper
})
